module.exports = __webpack_public_path__ + "media/PAG72-06.7a0ba78c.mp3";